import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import API from 'services/API';

type DeleteCustomTemplateArgs = {
  customTemplateUid: string;
};

const deleteCustomTemplate = async ({
  customTemplateUid,
}: DeleteCustomTemplateArgs) => {
  const response = await API.delete(
    `/api/internal/automation/custom-templates/${customTemplateUid}`,
  );
  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, DeleteCustomTemplateArgs>,
  'mutationFn'
>;

const useDeleteCustomTemplateMutation = (
  options?: ReactQueryMutationOptions,
) => {
  return useAppMutation({
    mutationFn: deleteCustomTemplate,
    ...options,
  });
};

export default useDeleteCustomTemplateMutation;
